<i18n lang="yaml">
zh:
  creative_space: "创作空间"
  my_work: "我的作品"
  breakdown_learning: "拆文学习"
  must_read: "入门必看"
  hot_tips: "爆款窍门"
  practical_video: "实操视频"
en:
  creative_space: "Creative Space"
  my_work: "My Work"
  breakdown_learning: "Breakdown Learning"
  must_read: "Getting Started"
  hot_tips: "Hot Tips"
  practical_video: "Practical Video"
</i18n>
<template>

    <!-- 菜单 -->
    <el-drawer
      class="custom-dialog-menu"
      ref="dialog"
      title=""
      :visible.sync="showMenuFlag"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-press-escape="true"
      :withHeader="showHeader"
      :destroy-on-close="true"
      :show-close="false"
      :wrapperClosable="false"
      :size="drawerWidth"
      @close="close"
      direction="ltr"
      :z-index="997"
      >
      <div class="custom-dialog-menu-slider-box">
        <div class="custom-dialog-menu-slider-box-item" :class="{'custom-dialog-menu-slider-box-active': sliderBoxActive == 0}" @click="sliderBoxActive = 0;$router.push('/home');setActiveMenuItem('1');close();">{{$t('creative_space')}}</div>
        <div class="custom-dialog-menu-slider-box-item" :class="{'custom-dialog-menu-slider-box-active': sliderBoxActive == 1}" @click="checkMyWork">{{$t('my_work')}}</div>
        <div class="custom-dialog-menu-slider-box-item" :class="{'custom-dialog-menu-slider-box-active': sliderBoxActive == 2}" @click="sliderBoxActive = 2;$router.push('/bookbreakdown/index');setActiveMenuItem('3');close();">{{$t('breakdown_learning')}}</div>
        <!-- <div class="custom-dialog-menu-slider-box-item">创作指南</div> -->
        <div class="custom-dialog-menu-slider-box-item" @click="goZhinan(1);close();" >{{$t('must_read')}}</div>
        <div class="custom-dialog-menu-slider-box-item" @click="goZhinan(2);close();" >{{$t('hot_tips')}}</div>
        <div class="custom-dialog-menu-slider-box-item" @click="goZhinan(3);close();" >{{$t('practical_video')}}</div>
        <div v-if="false" class="custom-dialog-menu-slider-box-item mali-disabled" :class="{'custom-dialog-menu-slider-box-active': sliderBoxActive == 3}" @click="sliderBoxActive = 3;$router.push('/bookbreakdown/index');close();">素材宝库(敬请期待)</div>
        <div v-if="false" class="custom-dialog-menu-slider-box-item mali-disabled" :class="{'custom-dialog-menu-slider-box-active': sliderBoxActive == 4}" @click="sliderBoxActive = 4;$router.push('/bookbreakdown/index');close();">灵感源泉(敬请期待)</div>
      </div>
    </el-drawer>
</template>
<script>
import { mapState, mapMutations} from 'vuex'
export default {
  name: 'malimenu',
  components: {

  },
  data() {
    return {
      sliderBoxActive: 0
    }
  },
  mounted() {
    console.log('mounted');
  },
  computed: {
    ...mapState(['showMenuFlag','token']),
    drawerWidth() {
      return window.innerWidth <= 768 ? '50%' : '50%';
    },
    showHeader() {
      return window.innerWidth <= 768
    },
  },
  created() {
    console.log('created');
  },
  methods: {
    ...mapMutations(['setShowMenuFlag','setActiveMenuItem','setShowLoginDialogFlag']),
    close(){
      this.setShowMenuFlag(false)
    },
    open(){
      this.setShowMenuFlag(true)
    },
    checkMyWork(){
      if(this.token==''){
        this.setShowLoginDialogFlag(true)
        this.close();
      }else{
        this.sliderBoxActive = 1;
        this.$router.push('/workspace/mywork');
        this.setActiveMenuItem('2');
        this.close();
      }
    },
    forceUpdate() {
      this.$forceUpdate(); // 强制重新渲染，以更新计算属性
    },
    goZhinan(index){
      let url = ''
      if(index == 1){
        url = 'https://qcnx120ai68z.feishu.cn/wiki/CuTuwXTpaifTflkpWiQcCZIlnSe?from=from_copylink'
      }else if(index == 2){
        url = 'https://qcnx120ai68z.feishu.cn/wiki/X6GswLv6xiNxm9kb3KxczTRdnDc?from=from_copylink'
      }else if(index == 3){
        url = 'https://qcnx120ai68z.feishu.cn/wiki/C8nnwi9NPi77ujkeW2RcnRglnxf?from=from_copylink'
      }
      window.open(url, '_blank')
      // document.location.href=url
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.forceUpdate);
  },
}
</script>

<style scoped lang="scss">
.custom-dialog-menu {
  ::v-deep .el-drawer__wrapper {
    z-index: 997 !important;
  }
  ::v-deep .el-drawer {
    background: transparent;
    border: none;
    box-shadow: none;
  }
  ::v-deep .el-drawer__body {
    margin-top: 2rem;
  }
  &-slider-box {
    display: flex;
    flex-direction: column;
    padding: 1rem 0.5rem;
    background: #E5E7FC;
    color: rgba(0, 0, 0, .8);
    border-radius: 0 20px 20px 0;
    height: 80%;
    &-item {
      border-radius: 20px;
      // flex:1;
      line-height: 2rem;
      cursor: pointer;
      margin: .25rem .25rem .25rem 2rem ;
      padding: 0 1rem;
      font-size: 14px;
    }
    &-active {
      background: #ffffff;
      color: #366EF4;
    }
  }
}
</style>
